import {
  GraduationCap,
  Users,
  Briefcase,
  Award,
} from "lucide-react";

function About() {
  const stats = [
    {
      icon: <Users size={32} />,
      number: "500+",
      title: "Students Trained",
    },
    {
      icon: <GraduationCap size={32} />,
      number: "5+",
      title: "Professional Courses",
    },
    {
      icon: <Briefcase size={32} />,
      number: "100+",
      title: "Projects Completed",
    },
    {
      icon: <Award size={32} />,
      number: "100%",
      title: "Practical Learning",
    },
  ];

  return (
    <section
      id="about"
      className="py-24 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">

        <div className="grid lg:grid-cols-2 gap-16 items-center">

          {/* Left */}

          <div>

            <span className="bg-blue-100 text-blue-700 px-4 py-2 rounded-full font-semibold">
              About Us
            </span>

            <h2 className="text-4xl lg:text-5xl font-bold mt-6 text-gray-900 leading-tight">
              Learn.
              <span className="text-blue-700"> Create.</span>
              <br />
              Innovate.
              <span className="text-blue-700"> Grow.</span>
            </h2>

            <p className="text-gray-600 mt-8 leading-8 text-lg">
              Digital with Priyanshi is a modern digital learning institute
              dedicated to transforming beginners into confident professionals
              through practical and industry-oriented education.
            </p>

            <p className="text-gray-600 mt-5 leading-8">
              Our courses focus on real-world projects, portfolio development,
              freelancing, interview preparation, and career guidance. Whether
              you're a student, entrepreneur, or working professional, we help
              you build skills that matter in today's digital world.
            </p>

            <button className="mt-8 bg-blue-700 hover:bg-blue-800 text-white px-7 py-3 rounded-full font-semibold transition">
              Learn More
            </button>

          </div>

          {/* Right */}

          <div className="grid grid-cols-2 gap-6">

            {stats.map((item, index) => (
              <div
                key={index}
                className="bg-blue-50 rounded-3xl p-8 shadow-md hover:shadow-xl hover:-translate-y-2 transition duration-300"
              >
                <div className="text-blue-700 mb-5">
                  {item.icon}
                </div>

                <h3 className="text-4xl font-bold text-gray-900">
                  {item.number}
                </h3>

                <p className="mt-3 text-gray-600">
                  {item.title}
                </p>

              </div>
            ))}

          </div>

        </div>

      </div>
    </section>
  );
}

export default About;